(function(){
  function getParam(name){
    try { return new URLSearchParams(window.location.search).get(name); }
    catch(e){ return null; }
  }

  function showOnly(target){
    var sections = document.querySelectorAll('[data-mascent-section]');
    if(!sections || !sections.length) return;

    // default to home
    var t = target || 'home';

    sections.forEach(function(el){
      var key = el.getAttribute('data-mascent-section');
      if(t === 'home'){
        el.style.display = '';
      } else {
        el.style.display = (key === t) ? '' : 'none';
      }
    });

    // scroll to top so it feels like a page
    if(t !== 'home'){
      window.scrollTo(0, 0);
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    var page = getParam('page');
    var allowed = ['home','ebooks','about','stories','free-chapter'];
    if(!page || allowed.indexOf(page) === -1){
      page = 'home';
    }
    showOnly(page);

    // simple active link styling
    var navLinks = document.querySelectorAll('[data-mascent-nav]');
    navLinks.forEach(function(a){
      var v = a.getAttribute('data-mascent-nav');
      if(page === v){
        a.style.color = 'var(--text)';
      }
    });
  });
})();
